// v1 learning from real messages. Schemas in api-learning.ts.
import * as A from './api-agent-runtime.js';
import * as L from './api-learning.js';
import { IdParam, items, route, W } from './route-def.js';

const Corr = W({ correctionId: IdParam });

export const learningRoutes = {
  createMessageCorrection: route({
    method: 'POST', path: '/workspaces/:workspaceId/conversations/:conversationId/messages/:messageId/corrections', summary: 'Señalar una respuesta real de LIA con una nota: respuesta de prueba + propuesta de instrucción', tag: 'learning',
    minRole: 'manager', params: W({ conversationId: IdParam, messageId: IdParam }), body: L.CreateMessageCorrectionSchema, response: L.MessageCorrectionSchema, status: 201,
  }),
  listConversationCorrections: route({
    method: 'GET', path: '/workspaces/:workspaceId/conversations/:conversationId/corrections', summary: 'Correcciones del equipo en una conversación (solo equipo)', tag: 'learning',
    minRole: 'advisor', params: W({ conversationId: IdParam }), response: items(L.MessageCorrectionSchema),
  }),
  updateMessageCorrection: route({
    method: 'PATCH', path: '/workspaces/:workspaceId/corrections/:correctionId', summary: 'Editar la instrucción propuesta', tag: 'learning',
    minRole: 'manager', params: Corr, body: L.UpdateMessageCorrectionSchema, response: L.MessageCorrectionSchema,
  }),
  applyMessageCorrection: route({
    method: 'POST', path: '/workspaces/:workspaceId/corrections/:correctionId/apply', summary: 'Agregar la instrucción al borrador del proyecto (se prueba y aprueba antes de publicar)', tag: 'learning',
    minRole: 'manager', params: Corr, response: L.MessageCorrectionSchema,
  }),
  rejectMessageCorrection: route({
    method: 'POST', path: '/workspaces/:workspaceId/corrections/:correctionId/reject', summary: 'Descartar la corrección', tag: 'learning',
    minRole: 'manager', params: Corr, response: L.MessageCorrectionSchema,
  }),
  saveCorrectionCase: route({
    method: 'POST', path: '/workspaces/:workspaceId/corrections/:correctionId/test-case', summary: '«Guardar este caso para futuras pruebas» (opcional: «Debe pasar antes de activar cambios»)', tag: 'learning',
    minRole: 'manager', params: Corr, body: L.SaveCorrectionCaseSchema, response: A.TestScenarioSchema, status: 201,
  }),
};
